/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Plan_Discount_Form_Activity_FeedInputs */

const en_admin_plan_discount_form_activity_feed = /** @type {(inputs: Admin_Plan_Discount_Form_Activity_FeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activity feed`)
};

const de_admin_plan_discount_form_activity_feed = /** @type {(inputs: Admin_Plan_Discount_Form_Activity_FeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivitäten`)
};

const es_admin_plan_discount_form_activity_feed = /** @type {(inputs: Admin_Plan_Discount_Form_Activity_FeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuente de actividad`)
};

const fr_admin_plan_discount_form_activity_feed = /** @type {(inputs: Admin_Plan_Discount_Form_Activity_FeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flux d'activités`)
};

const it_admin_plan_discount_form_activity_feed = /** @type {(inputs: Admin_Plan_Discount_Form_Activity_FeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feed attività`)
};

const pt_br2_admin_plan_discount_form_activity_feed = /** @type {(inputs: Admin_Plan_Discount_Form_Activity_FeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feed de atividades`)
};

const pl_admin_plan_discount_form_activity_feed = /** @type {(inputs: Admin_Plan_Discount_Form_Activity_FeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feed aktywności`)
};

const hu_admin_plan_discount_form_activity_feed = /** @type {(inputs: Admin_Plan_Discount_Form_Activity_FeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tevékenység folyam`)
};

const ro_admin_plan_discount_form_activity_feed = /** @type {(inputs: Admin_Plan_Discount_Form_Activity_FeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flux de activitati`)
};

/**
* | output |
* | --- |
* | "Activity feed" |
*
* @param {Admin_Plan_Discount_Form_Activity_FeedInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_plan_discount_form_activity_feed = /** @type {((inputs?: Admin_Plan_Discount_Form_Activity_FeedInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Plan_Discount_Form_Activity_FeedInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_plan_discount_form_activity_feed(inputs)
	if (locale === "de") return de_admin_plan_discount_form_activity_feed(inputs)
	if (locale === "es") return es_admin_plan_discount_form_activity_feed(inputs)
	if (locale === "fr") return fr_admin_plan_discount_form_activity_feed(inputs)
	if (locale === "it") return it_admin_plan_discount_form_activity_feed(inputs)
	if (locale === "pt-BR") return pt_br2_admin_plan_discount_form_activity_feed(inputs)
	if (locale === "pl") return pl_admin_plan_discount_form_activity_feed(inputs)
	if (locale === "hu") return hu_admin_plan_discount_form_activity_feed(inputs)
	return ro_admin_plan_discount_form_activity_feed(inputs)
});
export { admin_plan_discount_form_activity_feed as "admin.plan_discount_form.activity_feed" }